import React, { useState, useEffect } from "react";

import Progress from "react-progress-2";
import { Card, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import CardBody from "../../components/common/CardBody";
import ProductImage from "../../components/common/ProductImage";
import EditButton from "../../components/common/EditButton";
import ViewButton from "../../components/common/ViewButton";
import DeleteButton from "../../components/common/DeleteButton";
import CheckPermission from "../../components/roles/CheckPermission";
import { privateApi } from "../../api";

const BlogCategoryList = () => {
      const [loading, setLoading] = useState(false);
      const [categories, setCategories] = useState([]);
      const [totalCategories, setTotalCategories] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState("");

      const fetchCategories = async () => {
            setLoading(true);
            await privateApi
                  .get(
                        `/dashboard/blog_categories?limit=${limit}&search=${search}`
                  )
                  .then((response) => {
                        setCategories(response.data.categories);
                        setTotalCategories(response.data.totalBlogs);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            fetchCategories();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `/dashboard/blog_categories?page=${pageNumber}&limit=${limit}&search=${search}`;
            await privateApi(url)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories(response.data.categories);
                              setTotalCategories(response.data.totalBlogs);
                              setPerPages(response.data.itemsCountPerPage);
                              setCurrentPage(response.data.currentPage);
                        }
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleStatus = async (category) => {
            await privateApi
                  .post(`dashboard/blog_categories/${category.slug}/status`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (blog) => {
            const response = await privateApi
                  .delete(`dashboard/blog_categories/${blog.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setCategories((categories) =>
                                    categories.filter(
                                          (item) => item.id !== blog.id
                                    )
                              );
                              fetchCategories();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Category List">
                                          <LinkButton
                                                link="/dashboard/blogs/categories/create"
                                                title="Add New"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          perPages={perPages}
                                          totalItems={totalCategories}
                                          currentPage={currentPage}
                                          getData={getData}
                                          setSearch={setSearch}
                                    >
                                          <table className="table table-bordered table-hover">
                                                <thead>
                                                      <tr>
                                                            <th>#</th>
                                                            <th>Title</th>
                                                            <th>Blogs</th>
                                                            <th>Date</th>
                                                            <th width="100px">
                                                                  Status
                                                            </th>
                                                            <th width="120px">
                                                                  Action
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {!loading ? (
                                                            categories?.length >
                                                            0 ? (
                                                                  categories?.map(
                                                                        (
                                                                              blog,
                                                                              index
                                                                        ) => (
                                                                              <>
                                                                                    <tr
                                                                                          key={
                                                                                                index
                                                                                          }
                                                                                    >
                                                                                          <td>
                                                                                                {
                                                                                                      ++index
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <ProductImage
                                                                                                      image={
                                                                                                            blog.image
                                                                                                      }
                                                                                                      title={
                                                                                                            blog.title
                                                                                                      }
                                                                                                      category={`By: ${blog.user_name}`}
                                                                                                />
                                                                                          </td>
                                                                                          <td>
                                                                                                {
                                                                                                      blog.blogs
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                {
                                                                                                      blog.date
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <Form.Check
                                                                                                      type="switch"
                                                                                                      id="custom-switch"
                                                                                                      defaultChecked={
                                                                                                            blog.status ===
                                                                                                            1
                                                                                                                  ? true
                                                                                                                  : false
                                                                                                      }
                                                                                                      onClick={() =>
                                                                                                            handleStatus(
                                                                                                                  blog
                                                                                                            )
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                          <td className="text-center">
                                                                                                <EditButton
                                                                                                      link={`/dashboard/blogs/categories/${blog.slug}/edit`}
                                                                                                />
                                                                                                <ViewButton
                                                                                                      link={`/dashboard/blogs/categories/${blog.slug}/show`}
                                                                                                />
                                                                                                <CheckPermission permission="blog-category-delete">
                                                                                                      <DeleteButton
                                                                                                            item={
                                                                                                                  blog
                                                                                                            }
                                                                                                            loading={
                                                                                                                  loading
                                                                                                            }
                                                                                                            setLoading={
                                                                                                                  setLoading
                                                                                                            }
                                                                                                            handleDelete={
                                                                                                                  handleDelete
                                                                                                            }
                                                                                                      />
                                                                                                </CheckPermission>
                                                                                          </td>
                                                                                    </tr>
                                                                              </>
                                                                        )
                                                                  )
                                                            ) : (
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Blog
                                                                              Category
                                                                              Found
                                                                        </td>
                                                                  </tr>
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              Loading...
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )}
                                                </tbody>
                                          </table>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default BlogCategoryList;
